import { ErrorCode } from '@lessonPlanner/enums';

export const ERROR_MESSAGES = {
  [ErrorCode.UNKNOWN_ERROR]:
    'An unexpected error occurred. Double-check your entries and please try again later.',
  [ErrorCode.PROVIDER_ERROR]:
    'Something went wrong with our providers. Please try again later.',
  [ErrorCode.PROMPT_NOT_FOUND]:
    "Something's not quite right with the AI. Please try again later.",
  [ErrorCode.RATE_LIMIT]:
    'Too many requests. Please wait a moment before trying again.',
  [ErrorCode.REQUEST_TIMEOUT]: 'Request timed out. Please try again.',
  [ErrorCode.INVALID_INPUT]:
    'Invalid input provided. Please check your form entries.',
  [ErrorCode.SERVER_MODEL_ERROR]:
    'Our servers are experiencing issues. Please try again later.',
  [ErrorCode.API_KEY_ERROR]:
    'Our servers are experiencing issues. Please try again later.',
  [ErrorCode.INSUFFICIENT_CREDITS]:
    'Not enough credits available. Please top up to continue.',
  [ErrorCode.NETWORK_ERROR]:
    'Make sure you have good internet connection before trying again.',
};
